import { InjectionToken } from '@angular/core';

export const USER_HOME_ROUTE = new InjectionToken(
  'gdl.auth.core.user-home-route'
);
export const ANONYMOUS_HOME_ROUTE = new InjectionToken(
  'gdl.auth.code.anonymous-home-route'
);
export const AUTH_OPTIONS = new InjectionToken('gdl.auth.options');
